import { useEffect, useState } from "react";
import { ShieldCheck } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { AdminShell } from "@/components/Layout";

const LABEL = { billing: "Billing", branding: "Branding", team: "Team", inbox_setup: "Live Email Sync", sms_photos: "SMS / Twilio",
  emergency_dispatch: "Emergency Dispatch", integrations: "Integrations", kraaft: "Kraaft" };

// Call from any sensitive page: useAccessLog("billing")
export function useAccessLog(page) {
  useEffect(() => { api.post("/access/log", { page, path: window.location.pathname }).catch(() => {}); }, [page]);
}

export default function AdminAccessLog() {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get("/access/log").then(r => setRows(r.data.rows)).catch(e => setErr(e.response?.data?.detail || "Founder only")); }, []);
  return (
    <AdminShell>
      <div className="p-4 md:p-6 max-w-4xl space-y-4" data-testid="access-log-page">
        <div className="flex items-center gap-3">
          <ShieldCheck weight="fill" size={26} className="text-slate-800"/>
          <div>
            <h1 className="text-2xl font-black uppercase tracking-tight">Access Log</h1>
            <p className="text-xs text-slate-600">Who opened Billing, Branding, Team, Email Sync, SMS, Emergency Dispatch — and when. Founder-only. Repeat views within 10 minutes are grouped.</p>
          </div>
        </div>
        {err && <div className="border-2 border-red-400 bg-red-50 p-3 text-sm font-bold text-red-800" data-testid="access-log-error">{err}</div>}
        {rows && rows.length === 0 && <div className="text-sm text-slate-500">Nothing logged yet.</div>}
        {rows && rows.length > 0 && (
          <div className="border-2 border-slate-900 bg-white divide-y divide-slate-100">
            {rows.map(r => (
              <div key={r.id} className={`p-3 flex items-center gap-3 text-xs ${r.is_founder ? "opacity-60" : ""}`} data-testid={`access-row-${r.id}`}>
                <span className="text-[9px] font-black uppercase tracking-widest px-2 py-0.5 bg-slate-900 text-white shrink-0">{LABEL[r.page] || r.page}</span>
                <div className="flex-1 min-w-0">
                  <div className="font-bold text-slate-900 truncate">{r.user_name} <span className="text-slate-400 font-normal">· {r.office_role || r.role}{r.is_founder ? " · you" : ""}</span></div>
                  <div className="text-slate-500">{new Date(r.at).toLocaleString()}{r.views > 1 ? ` · ${r.views} views (last ${new Date(r.last_at).toLocaleTimeString()})` : ""}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </AdminShell>
  );
}
